// The status badge (web/controls.js renderBadge): "Loading…" until the first events arrive; hidden once they have
// (or "Finding you…" while the locate button waits for a fix); a warning that retries when tapped when the server
// can't be reached ("Offline · saved 5 min ago · retry" when the saved copy is showing).
import { retryLoad } from "../data/load";
import { T } from "../shared/config";
import { useFeed } from "../state/feed";
import { useView } from "../state/view";
import styles from "./Badge.module.css";

function timeAgo(d: Date) {
  const m = Math.round((Date.now() - +d) / 60e3);
  if (m < 1) return "just now";
  if (m < 60) return `${m} min ago`;
  const hrs = Math.round(m / 60);
  return hrs < 24 ? `${hrs}h ago` : `${Math.round(hrs / 24)}d ago`;
}

export function Badge() {
  const source = useFeed((s) => s.source), cachedAt = useFeed((s) => s.cachedAt), finding = useView((s) => s.findingYou);
  const warn = source === "cached" || source === "error";
  const text = source === "loading" ? "Loading…"
    : source === "server" ? T("locate.finding")
    : source === "cached" ? `Offline · saved ${cachedAt ? timeAgo(cachedAt) : "earlier"} · retry`
    : "Can't reach the Nowish server · retry";
  return (
    <button type="button" id="badge" data-source={source} className={warn ? `${styles.badge} ${styles.warn}` : styles.badge}
      hidden={source === "server" && !finding} disabled={!warn} onClick={() => void retryLoad()}>
      {text}
    </button>
  );
}
